(function(){
  if(window.__sssCampaignTimerInitialized)return;
  window.__sssCampaignTimerInitialized=true;
  function tick(){
    document.querySelectorAll('[data-sss-timer]').forEach(function(el){
      var finish=Date.parse(el.getAttribute('data-sss-timer')||'');
      var remaining=finish-Date.now();
      if(!Number.isFinite(finish)||remaining<=0){el.hidden=true;return;}
      var seconds=Math.floor(remaining/1000);
      var days=Math.floor(seconds/86400);seconds%=86400;
      var hours=Math.floor(seconds/3600);seconds%=3600;
      var minutes=Math.floor(seconds/60);seconds%=60;
      var pad=function(n){return String(n).padStart(2,'0')};
      var text=(days?days+'d ':'')+pad(hours)+':'+pad(minutes)+':'+pad(seconds);
      var clock=el.querySelector('.sss-campaign-timer__clock');
      if(clock)clock.textContent=text;
      el.hidden=false;
    });
  }
  tick();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',tick);
  document.addEventListener('shopify:section:load',tick);
  setInterval(tick,1000);
})();